export default __webpack_public_path__ + "static/media/user5.847ea5a9.jpg";